// /src/Reducers/index.js
const initialState = {
  NOTIFICATION_COUNT: 0,
};

export default function adminReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_NOTIFICATION_COUNT":
      return {
        ...state,
        NOTIFICATION_COUNT: action.payload,
      };
    case "DECREMENT_NOTIFICATION_COUNT":
      return {
        ...state,
        NOTIFICATION_COUNT: Math.max(0, (state.NOTIFICATION_COUNT || 0) - 1),
      };
    default:
      return state;
  }
}
